<template>
  <div class="main">
    <div class="pageTitle">
      <p>项目工时统计 - 按月度</p>
      <span style="margin-left:20px;font-size:14px;line-height:40px;">单位：人天</span>
      <div style="float:right">
        <currentDate @pageReadyFunc="pageReadyFunc"></currentDate>
      </div>
    </div>
    <div class="searchArea">
      <div class="weekly_search">
        <div class="search_input">
          <el-input :value="listQuery.Parameters.projectName" readonly></el-input>
          <div class="tableChoose_btn">
                        <el-button
                          type="text"
                          size="medium"
                          @click="showChooseProjectView()">选择</el-button>
                        <el-button
                          type="text"
                          size="medium"
                          @click="clearProject()">清除</el-button>
                      </div>
        </div>

         <!-- <div class="search_select">
          <el-select v-model="listQuery.Parameters.startYear" placeholder class="selectYear">
            <el-option v-for="item in yearList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
          </el-select>
          <el-select
            v-model="listQuery.Parameters.startMonth"
            placeholder
            class="selectMonth">
            <el-option v-for="item in monthList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
          </el-select>
        </div>
        <span>至</span>
        <div class="search_select">
          <el-select v-model="listQuery.Parameters.endYear" placeholder class="selectYear">
            <el-option v-for="item in yearList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="listQuery.Parameters.endMonth" placeholder class="selectMonth">
            <el-option
              v-for="item in monthList"
              :key="item.id"
              :label="item.Name"
              :value="item.id"
              style="padding-left:10px;"
            ></el-option>
          </el-select>
        </div> -->

         <div class="search_select">
            <el-date-picker
              v-model="monthRange"
              type="monthrange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :picker-options="pickerOptions">
            </el-date-picker>
        </div>  

        <div style="display: inline-block;">
          <el-button size="small" @click="searchTable">查询</el-button>
          <el-button size="small" @click="clearQueryParameters">清除</el-button>
          <el-button size="small" @click="exportToExcel">导出查询结果</el-button>
        </div>
      </div>
    </div>
 <div class="tableContainer" style="top: 120px;">
   <div class="tableContent">
        <el-table :data="spentTimeData" border stripe>
           <el-table-column prop="projectSerialNumber" label="项目编号" width="200" fixed="left"></el-table-column>
          <el-table-column label="项目" width="300" fixed="left">
            <template slot-scope="props">
              <el-button type="text" size="mini" @click="showProjectReportView(props.row)">
                {{
                props.row.projectName
                }}
              </el-button>
            </template>
          </el-table-column>

           <el-table-column label="总计" width="100">
              <template slot-scope="props">
                {{props.row.spentTime | hoursToDays}}
              </template>
           </el-table-column>
          <el-table-column v-for="val in monthColumnList" :key="val" width="120">
            <template slot="header">
              {{
              val.split('-')[1]
              }}-
              {{
              val.split('-')[2]
              }}
            </template>
            <template slot-scope="props">{{props.row[val]| hoursToDays}}</template>
          </el-table-column>
        </el-table>
      </div>
     
        <div class="tablePagesNumber">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.PagingInfo.currentPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="listQuery.PagingInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery.PagingInfo.totalCount"
          ></el-pagination>
        </div>
      </div>

    <chooseProject
        ref="chooseProject"
        :propsData="projectChooseViewProps"
        @chooseProjectCallback="chooseProjectCallback"></chooseProject>

    <projectReportDialog
      ref="projectReportDialog"
      :projectReportDialogProps="projectReportDialogProps"></projectReportDialog>

  </div>
</template>
<script>
import { dateFtt } from "@/utils/auth.js";
import currentDate from "../common/currentDate";
import chooseProject from "../common/chooseProject";
import projectReportDialog from "../report/projectReportDialog";

export default {
  name: "monthlySpentTimeGroupByProject",
  components: {chooseProject, currentDate ,projectReportDialog},
  data() {
    return {
      projectReportDialogProps: {
        visible: false
      },
      monthRange: null,
      pickerOptions: {
          shortcuts: [{
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          }, {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 5);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      projectChooseViewProps: {
        visible: false,
        includeRemoved:true
      },
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          projectId: "",
          projectName:"",
          startYear: "",
          startMonth: "",
          endYear: "",
          endMonth: ""
        }
      },
      spentTimeData: [],
      monthColumnList:[],
       monthList: [
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
        { id: "4", name: "4" },
        { id: "5", name: "5" },
        { id: "6", name: "6" },
        { id: "7", name: "7" },
        { id: "8", name: "8" },
        { id: "9", name: "9" },
        { id: "10", name: "10" },
        { id: "11", name: "11" },
        { id: "12", name: "12" }
      ],
      yearList: [],
    };
  },
  mounted() {

     const end = new Date();
     const start = new Date();
     start.setMonth(start.getMonth() - 2);

     this.monthRange = new Array();
     this.monthRange.push(start);
     this.monthRange.push(end);

     this.searchTable();
  },
  methods: {
    // 获取当前日期后的回调
    pageReadyFunc(currentWeekInfo) {

    },

    showProjectReportView(current) {
      this.$refs.projectReportDialog.show(current.projectId);
    },

    //获取时间
    getYearList() {
      this.$dateTimeHelperApi.getYearList().then(res => {
        if (res.data.successful) {
          this.yearList = [];
          let list = res.data.data;
          list.forEach(item => {
            this.yearList.push({ id: item, name: item });
          });
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },

    getSearchArgs()
    {
        //alert(this.monthRange);
      if(this.monthRange!=null)
      {
        //alert(this.monthRange);
          this.listQuery.Parameters.startYear = this.monthRange[0].getFullYear();
          this.listQuery.Parameters.startMonth = this.monthRange[0].getMonth() + 1;
          this.listQuery.Parameters.endYear = this.monthRange[1].getFullYear();
          this.listQuery.Parameters.endMonth = this.monthRange[1].getMonth() + 1;
      }else{
          this.listQuery.Parameters.startYear = "";
          this.listQuery.Parameters.startMonth = "";
          this.listQuery.Parameters.endYear = "";
          this.listQuery.Parameters.endMonth = "";
      }
    },

    searchTable() {
      
      this.getSearchArgs();

      this.$reportApi.getMonthlySpentTimeDataTableGroupByProject(this.listQuery)
        .then(res => {
          if (res.data.successful) {
            this.spentTimeData = res.data.data.data;
            this.listQuery.PagingInfo.totalCount = res.data.data.pagingInfo.totalCount;
            
            this.getTableColumnList()

          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    },

    exportToExcel()
    {
      this.getSearchArgs();
      
      this.$reportApi.exportMonthlySpentTimeDataTableGroupByProject(this.listQuery)
      .then(res => {
        console.log(res);
          if (res.data.successful) {
            window.open(window.Glob.BASE_URL + "/" + res.data.data.url);
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    },

    clearQueryParameters(){
        this.listQuery.Parameters.projectId = "";
        this.listQuery.Parameters.projectName = "";
        this.monthRange = null;
    },

    getTableColumnList(){
        let monthColumnList = [];
        this.spentTimeData.forEach(item=>{
            for(let key in item){
                if(key.indexOf('-') !='-1'){
                    monthColumnList.push(key)
                }
            }
        })
        // 数组去重
        this.monthColumnList =[...new Set(monthColumnList)];
    },
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.searchTable();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.searchTable();
    },

    //选择项目弹窗
    showChooseProjectView() {
      this.$refs.chooseProject.show();
    },

    //选择项目回调
    chooseProjectCallback(args) {
      this.projectChooseViewProps.visible = false;

      this.listQuery.Parameters.projectId = args.id;
      this.listQuery.Parameters.projectName = args.name;

    },

     //清除项目
    clearProject() {
      this.listQuery.Parameters.projectId = "";
      this.listQuery.Parameters.projectName = "";
    },
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.el-tabs.el-tabs--top {
  margin-top: 20px;
}
.el-tabs__active-bar {
  background-color: #95b4d1;
}
.search_input {
  width: 220px;
  position: relative;
  display: inline-block;
  margin-right: 10px;
}
.search_select {
  display: inline-block;
  margin-left: 20px;
}
.weekly_search {
  margin-top: 20px;
}
.selectYear {
  width: 80px;
}
.selectMonth {
  width: 60px;
}
.selectMonth .el-input__inner,
.selectYear .el-input__inner {
  padding-left: 10px !important;
}
// .weekly_search .el-input {
//   width: 150px;
// }
</style>



// WEBPACK FOOTER //
// src/views/report/monthlySpentTimeGroupByProject.vue